import { REPORT_NILAI_BARANG_PER_PELABUHAN } from "./../actions/reportNilaiBarangPerPort";
const initial_state = {
    loading: false,
    error: false,
    success: false,
    data: null,
};

const reportNilaiBarangPerPortReducer = (state = initial_state, action) => {
    switch (action.type) {
        case REPORT_NILAI_BARANG_PER_PELABUHAN + "_LOADING":
            return {
                loading: true,
                error: false,
                success: false,
                data: null,
            };
        case REPORT_NILAI_BARANG_PER_PELABUHAN + "_ERROR":
            return {
                loading: false,
                error: true,
                success: false,
                data: null,
            };
        case REPORT_NILAI_BARANG_PER_PELABUHAN + "_SUCCESS":
            return {
                loading: false,
                error: false,
                success: true,
                data: action.payload,
            };
        default:
            return state;
    }
};

export default reportNilaiBarangPerPortReducer;
